import { HttpErrorResponse } from '@angular/common/http';
import { OnInit, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { FormGroup, Validator, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
import { ContactDetails, ContactResponse } from '../../models/contact.model';
import { ContractSession } from '../../models/contractsession.model';
import { ContractsAzureDetailsResponse, ContractsSingalFile, GenerateContractsAzure, GenerateContractsAzureResponse } from '../../models/document.model';
import { ContactService } from '../../services/contact.service';
import { ContractSessionService } from '../../services/contractsession.service';
import { DocumentService } from '../../services/document.service';
import { InventionService } from '../../services/invention.service';
import { UtilityService } from '../../services/shared/utility.service';

//For jquery
declare var $: any;

@Component({
    selector: 'app-cust-contract',
    templateUrl: './cust-contract.component.html',
    styleUrls: ['./cust-contract.component.css']
})
/** cust-contract component*/
export class CustContractComponent implements OnInit {
    /** cust-contract ctor */
    displayedGenContractColumns = ['fileName', 'dtCreated', 'unZipDoc', 'zipDoc'];
    displayedSingleFileColumns = ['fileName', 'unZipDoc'];
    gencontractDetailsResponse: ContractsAzureDetailsResponse;
    generateContractsAzure: GenerateContractsAzure[];
    dataSourceSingleFile: any;
    @ViewChild('sortDocPopUp') sortDocPopUp: MatSort;
    contractSessionId: any;
    public contractSession: ContractSession;
    containerName: string = 'contih';
    dvSpinner: boolean = false;
    chkExpPDF: boolean = false;
    isUserAuth: boolean = false;
    isExecuted: boolean = false;
    authMsg: string = '';
    encryptedUser: string = 'dfsfsdjfjsdfj';
    private contactDetails: ContactDetails;
    private contactResponse: ContactResponse;
    contactId: number;
    inventionId: number = 1;
    customerForm: FormGroup;
    panelTitle: string = 'Latest Document';
    dataSourceGenContract: any;
    userMessage: string;
    loading: boolean = false;
    popLoading: boolean = false;
    pop2Loading: boolean = false;
    singalDownload: ContractsSingalFile[] = [];
    logoPath: string = "";
    public appVersion;
    cancelValue: string = 'false';

    constructor(private fb: FormBuilder,
        private _route: ActivatedRoute,
        private _documentService: DocumentService,
        private _utilityService: UtilityService,
        private _inventionService: InventionService,
        private _contractSessionService: ContractSessionService,
        private _contactService: ContactService,) {
        this.appVersion = environment.appVersion;
        this._route.paramMap.subscribe(async params => {
            if (params.has('contact')) {

                this.contactId = +params.get('contact');
            }
            if (params.has('contractSessionId')) {

                this.contractSessionId = +params.get('contractSessionId');
                this._route.queryParamMap.subscribe(async qparam => {
                    this.cancelValue = qparam.get('isCancel')
                })
                if (this.cancelValue == 'true')
                    this.DownloadContractDetails(this.contractSessionId);
                else
                    this.loadContractSession();
            }
        });

        //this._route.queryParamMap.subscribe(params => {
        //    if (params.has('cs')) {
        //        this.contractSessionId = params.get('cs');
        //    }
        //});
    }

    ngOnInit(): void {
        this.loadCustForm();
        this.loadContact();
    }

    async GetGenerateContractDetails() {

        await this._documentService.getLatestContractsAzureDetailsAsync("sgsdfsfsfjh", this.contractSessionId)
            .then(res => {
                if (res)
                    this.gencontractDetailsResponse = UtilityService.clone(res);
                if (this.gencontractDetailsResponse) {
                    this.generateContractsAzure = UtilityService.clone(this.gencontractDetailsResponse.getGenerateContractsAzure);
                    if (this.generateContractsAzure) {
                        this.isExecuted = this.generateContractsAzure.find(rows => rows.filePath != '' && rows.productId > 0) ? true : false;
                        const ELEMENT_DATA: GenerateContractsAzure[] = this.generateContractsAzure;
                        this.dataSourceGenContract = new MatTableDataSource(ELEMENT_DATA);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);

            });
    }

    downloadFile(fileName, containerName, source) {
        if (source == 'popup')
            this.popLoading = true;
        else
            this.loading = true;
        this._documentService.getContractsAzureZipEncriptAsync('hgfhfgg', fileName, containerName, "AllFiles", this.contractSessionId, true)
            .then(async (result: any) => {
                if (result) {
                    let file = new Blob([result], { type: 'application/zip' });
                    let fileURL = URL.createObjectURL(file);
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.download = fileName;
                    fileLink.click();
                    this.dvSpinner = false;
                    this.chkExpPDF = false;
                    this.loading = false;
                    this.popLoading = false;

                } else {
                    this.loading = false;
                    this.popLoading = false;
                    console.log("exportTozip.statusCode: Error Getting Data");
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.loading = false;
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);

            });

    }
    async getCompressedFiles(fileName: string, containerName: string, source: string) {
        if (source == 'popup')
            this.popLoading = true;
        else
            this.loading = true;
        this._documentService.getCompressedFileNamesAsync(this.encryptedUser, fileName, containerName, this.contractSessionId, true)
            .then(async (result: any) => {
                if (result) {
                    var str_array = result.split(',');
                    this.createListItem(fileName, str_array);
                    this.loading = false;
                    this.popLoading = false;
                } else {
                    this.loading = false;
                    this.popLoading = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.loading = false;
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });

    }
    createListItem(fileName: string, str_array: any): void {
        this.singalDownload = [];
        for (var i = 0; i < str_array.length; i++) {
            this.singalDownload.push({ zipName: fileName, fileName: str_array[i] });
        }
        const ELEMENT_DATA: ContractsSingalFile[] = UtilityService.clone(this.singalDownload);;
        this.dataSourceSingleFile = new MatTableDataSource(ELEMENT_DATA);
        this.dataSourceSingleFile.sort = this.sortDocPopUp;
        $('#modalExportCompressFile').modal('show');
    }
    downloadSingalFile(zipName, containerName, fileName) {
        this.pop2Loading = true;
        var fileExtensio = fileName.split('.').pop();
        this._documentService.getContractsAzureZipEncriptAsync(this.encryptedUser, zipName, containerName, fileName, 0, false)
            .then(async (result: any) => {
                if (result) {
                    if (fileExtensio.toLowerCase() == 'pdf') {
                        let file = new Blob([result], { type: 'application/pdf' });
                        if (this.cancelValue == 'true')
                            window.open(URL.createObjectURL(file), '_self');
                        else
                            window.open(URL.createObjectURL(file), '_blank');
                    }
                    else {
                        let file = new Blob([result]);
                        let fileURL = URL.createObjectURL(file);
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.download = fileName;
                        fileLink.click();
                    }
                    this.pop2Loading = false;
                    this.loading = false;
                    this.popLoading = false;
                }
                else {
                    this.pop2Loading = false;
                    this.loading = false;
                    this.popLoading = false;
                }
            }).catch((err: HttpErrorResponse) => {
                this.pop2Loading = false;
                this.loading = false;
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });
    }
    async downloadUnZipFile(fileName: string, containerName: string, source: string) {

        this.popLoading = true;
        this._documentService.getContractsAzureZipEncriptAsync(this.encryptedUser, fileName, containerName, "AllFiles", 0, false)
            .then(async (result: any) => {
                if (result) {
                    console.log('downloadFile-' + result);
                    let file = new Blob([result], { type: 'application/zip' });

                    let fileURL = URL.createObjectURL(file);
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.download = fileName;
                    fileLink.click();
                    this.popLoading = false;
                } else {
                    console.log("exportToZIP.statusCode: Error Getting Data");
                    this.popLoading = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });

    }
    async loadContact() {

        await this._contactService.getContactAsync(this.encryptedUser, this.contactId)
            .then(async (result: ContactResponse) => {
                if (result) {
                    if (result.statusCode == 0) {

                        this.contactResponse = UtilityService.clone(result);
                        if (this.contactResponse) {
                            this.contactDetails = UtilityService.clone(this.contactResponse.contactDetails);
                        }
                    }
                }
            })
    }

    private loadContractSession() {
        if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
            this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                .then(async res => {
                    if (res) {
                        this.contractSession = UtilityService.clone(res);
                        //this.logoPath = this.contractSession.productId > 8 ? "assets/images/logo/Patent-Plus.png" : "assets/images/logo/logo_1226.png";
                        this.logoPath = "assets/images/logo/logo_1226.png";
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    validateUserPhone() {
        let regPhone: number;
        let authPhone: number;
        this.authMsg = "";
        if (this.contactDetails) {
            authPhone = this.customerForm.controls.userPhone.value;
            regPhone = parseInt(this.contactDetails.mobile.substr(this.contactDetails.mobile.length - 4));

            if (authPhone == null) {
                this.authMsg = "Please enter your vaild phone last 4 digits before submit.";
                return;
            }
            if (authPhone == regPhone) {
                this.isUserAuth = true;
                this.userMessage = "Document not generated yet.";
                this.GetGenerateContractDetails();
            }
            else {
                this.isUserAuth = false;
                this.authMsg = "Authentication Failed! Please enter your vaild phone last 4 digits."
            }
        }
    }
    get form() { return this.customerForm.controls; }

    private prepareCustDocumentForm(): FormGroup {
        return this.fb.group({


            /*User Authentication Starts*/
            userPhone: [{ value: '' }, [Validators.required, Validators.pattern(/^[0-9]{0,4}$/)]],
            /*User Authentication Starts*/

        });
    }

    loadCustForm() {
        this.customerForm = this.prepareCustDocumentForm();
        this.customerForm.reset();
    }

    hideFilesList() {
        $('#modalExportCompressFile').modal('hide');
    }

    async DownloadContractDetails(_contractSessionId) {

        await this._documentService.getLatestContractsAzureDetailsAsync("sgsdfsfsfjh", _contractSessionId)
            .then(res => {
                if (res)
                    this.gencontractDetailsResponse = UtilityService.clone(res);

                if (this.gencontractDetailsResponse) {
                    this.generateContractsAzure = UtilityService.clone(this.gencontractDetailsResponse.getGenerateContractsAzure);
                    if (this.generateContractsAzure) {
                        this.getCompressedFile(this.generateContractsAzure[0].fileName, 'contih');
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);

            });
    }

    getCompressedFile(fileName: string, containerName) {
        this._documentService.getCompressedFileNamesAsync(this.encryptedUser, fileName, containerName, this.contractSessionId, true)
            .then(async (result: any) => {
                if (result) {
                    var str_array = result.split(',');
                    for (var i = 0; i < str_array.length; i++) {
                        this.downloadSingalFile(fileName, 'contih', str_array[i]);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.loading = false;
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });
    }
}
